export const capitalizeFirstLetter = (str: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : ''

export const resolveBooleanString = (str: string): boolean | null => {
  const lowerCase = str.toLowerCase()

  if (lowerCase === 'true') {
    return true
  }

  if (lowerCase === 'false') {
    return false
  }

  return null
}
